namespace ui
{
	export namespace base
	{

		export type ButtonContext	= 'default'|'primary'|'success'|'info'|'warning'|'danger';
		export type ButtonSize		= 'xs'|'sm'|'lg';

		export interface IButtonOptions extends IBaseHTMLElementDescriptor
		{
			context?:	ButtonContext;
			size?:		ButtonSize;
		}

		export class Button
			extends HTMLPresentation<HTMLButtonElement>
		{

			public readonly	Descriptor:	IButtonOptions;

			public constructor( title?: string|number|JQuery|BaseHTMLElement, options?: IButtonOptions )
			{
				super( 'button' );

				this.Descriptor	= this.PreprocessOptions( options || {} );

				if ( title ) { this.append( typeof title !== 'object' ? ui.$$.text( title.toString() ) : title ); }
			}

			public Initialize(): Button
			{
				super.Initialize( this.Descriptor );

				if ( this.Descriptor.context ) { this.addClass( 'btn-' + this.Descriptor.context ); }

				if ( this.Descriptor.size ) { this.addClass( 'btn-' + this.Descriptor.size ); }

				return this;
			}

			public rebuild( root: JQuery|BaseHTMLElement ): Button
			{
				super.rebuild( root );

				return this.Initialize();
			}

			protected PreprocessOptions( options: IButtonOptions ): IButtonOptions
			{
				if ( !options.classes )
				{
					options.classes	= new Array<string>();
				}

				options.classes.splice( 0, 0, 'btn' );

				if ( !options.context )	{ options.context	= 'default'; }

				return options;
			}

		}

	}
}
